const urlProtocolRegex = /^https?:\/\//;

export const isInAppBrowser = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  // HACK: Check if the link is opened in the Telegram webview
  // https://github.com/shalanah/inapp-spy/issues/30#issuecomment-2417412275
  if (
    typeof window.TelegramWebview !== 'undefined' ||
    window.TelegramWebviewProxy !== 'undefined' ||
    window.TelegramWebviewProxyProto !== 'undefined'
  ) {
    return true;
  }

  return /Instagram|FBAN|FBAV|FB_IAB|Messenger|Line|Snapchat|TikTok|Twitter|Pinterest|LinkedIn|WeChat|Telegram|Reddit/.test(
    navigator.userAgent
  );
};

const useInAppBrowser = ({ url }) => {
  const handleLinkClick = (e) => {
    if (isInAppBrowser()) {
      e.preventDefault();

      const userAgent = navigator.userAgent;
      const isIOS = /iPhone|iPad|iPod/.test(userAgent);
      const isAndroid = /Android/.test(userAgent);

      let formattedUrl = url.replace(urlProtocolRegex, '');

      if (isIOS) {
        window.location.href = `x-safari-https://${formattedUrl}`;
      } else if (isAndroid) {
        window.location.href = `intent://${formattedUrl}#Intent;scheme=https;package=com.android.chrome;end`;
      } else {
        window.open(url, '_blank', 'noreferrer');
      }
    }
  };

  return { handleLinkClick };
};

export default useInAppBrowser;
